import { deleteBiddingBlockApprovalRequest } from '@ebalance/proto/bffuser/v1/bidding_block_service-BiddingBlockService_connectquery'

import { blockApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * ブロック入札 承認依頼 削除 mutation hook (楽観ロック使用)。
 * onSuccess で list / detail query を invalidate する。
 */
export function useDeleteBiddingBlockApprovalRequest(): InvalidatingMutationResultFor<
  typeof deleteBiddingBlockApprovalRequest
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(
      deleteBiddingBlockApprovalRequest,
      blockApprovalRequestInvalidationKeys,
    ),
  )
}
